import React from "react"
import PropTypes from "prop-types"

import { Dropdown } from "ui"
import WithRecords from "data/wrappers/WithRecords"

class RecordDropdown extends React.Component {
    render() {
        return (
            <WithRecords objectId={this.props.objectId}>
                {({ records, primaryField }) => {
                    return (
                        <Dropdown
                            {...this.props}
                            options={recordsToOptions(records || [], primaryField)}
                        />
                    )
                }}
            </WithRecords>
        )
    }
}

const recordsToOptions = (records, primaryField) => {
    return records.map(record => ({
        label: record[primaryField.api_name],
        value: record._sid,
    }))
}

RecordDropdown.propTypes = {
    objectId: PropTypes.string,
}

export default RecordDropdown



// WEBPACK FOOTER //
// ./src/features/records/components/RecordDropdown.js